import {ActionType, appStateType, reducerStoreType, SOCKET_STATUS} from "./types";

const defaultState = {
    userInfo: undefined,
    currentStore: -1,
    socketStatus: SOCKET_STATUS.DISCONNECT,
    resetButtonCountDown: 0
}


const app = (state: appStateType = defaultState, action: ActionType<any>) => {
    switch (action.type) {
        case 'SET_USER_INFO':
            return {
                ...state,
                userInfo: action.payload
            }
        case 'TOP_BAR_CHANGE_CURRENT_STORE':
            return {
                ...state,
                currentStore: Number(action.payload.storeId)
            }
        case 'SET_USER_ROLE':
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                    role: action.payload.role
                }
            }
        case 'SOCKET_CONNECTED':
            return {
                ...state,
                socketStatus: SOCKET_STATUS.CONNECTED
            }
        case 'SOCKET_DISCONNECTED':
            return {
                ...state,
                socketStatus: SOCKET_STATUS.DISCONNECT
            }
        case 'USER_EMAIL_CHANGE':
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                    email: action.payload.email
                }
            }
        case 'SEND_BUTTON_STATUS':
            return {
                ...state,
                resetButtonCountDown: action.payload.countdown
            }
        default:
            return state;
    }
}
export const getUserInfo = (state: reducerStoreType) => (state.app.userInfo)
export const getCurrentStore = (state: reducerStoreType) => (state.app.currentStore === -1 ? null : state.app.currentStore)


export default app